import { FlexRow } from '@/components/common/Flex';
import { FlexProps } from '@chakra-ui/react';
import { ICON_BG_SIZES } from '@common/react/icons';
import { isIconSize } from './IconComponent';

interface IconBackgroundProps extends FlexProps {
    shape?: 'square' | 'circle';
    size?: FlexProps['w'];
}

export default function IconBackground({
    shape = 'square',
    size = 'md',
    bg = 'gray.200',
    ...props
}: IconBackgroundProps) {
    if (isIconSize(size)) {
        size = ICON_BG_SIZES[size];
    }

    return (
        <FlexRow
            w={size}
            minW={size}
            maxW={size}
            h={size}
            minH={size}
            maxH={size}
            alignItems="center"
            justifyContent="center"
            bg={bg}
            borderRadius={shape === 'square' ? 'md' : 'full'}
            {...props}
        />
    );
}
